import { Component, createElement } from 'react';
import { connect } from 'react-redux';
import { createCommand } from '@mews-commander/legacy-entities/src/actions/commands';

interface Props {
    createCommand?: $TSFixMeFunction;
    close?: $TSFixMeFunction;
    action?: {
        onClick?: $TSFixMeFunction;
        url?: string;
        parameters?: {};
        successMessageKey?: string;
        text?: React.ReactNode;
        icon?: string;
    };
}

class CommandAction extends Component<Props> {
    handleClick = () => {
        // @ts-expect-error $TSFixMeError: Property 'url' does not exist on type '{ onClick?: $TSFixMeFunction | undefined; url?: string | undefined; parameters?: ...
        const { url, parameters, successMessageKey, onClick } = this.props.action;

        // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
        this.props.createCommand(url, parameters, successMessageKey);
        if (onClick) {
            onClick();
        }
        if (this.props.close) {
            this.props.close();
        }
    };

    render() {
        // @ts-expect-error $TSFixMeError: Property 'component' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
        const { action, component } = this.props;
        // @ts-expect-error $TSFixMeError: Property 'text' does not exist on type '{ onClick?: $TSFixMeFunction | undefined; url?: string | undefined; parameters?:...
        const { text, icon, disabled } = action;

        return createElement(component, {
            title: text,
            icon,
            onClick: this.handleClick,
            size: 'small',
            disabled,
        });
    }
}

export default connect(undefined, {
    createCommand,
})(CommandAction);
